import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { isPresent, pixify } from '@seedlang/utils';
import Link from 'components/link';

const Wrapper = styled.div`
  margin: ${props => props.margin};
  font-size: ${props => props.fontSize};
  height: ${props => props.height};
  font-weight: bold;
`;

const Breadcrumb = styled.span`
  line-height: 26px;
  overflow-wrap: break-word;
  word-break: break-word;
  .fa-angle-double-right {
    margin: 0 5px;
    vertical-align: baseline;
  }
`;

const BreadcrumbLink = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
  &:hover {
    color: inherit;
  }
`;

const BreadcrumbText = styled.span`
  text-decoration: normal;
  cursor: default;
`;

@observer
class Breadcrumbs extends React.Component {

  static defaultProps = {
    margin: 0,
    fontSize: '16px',
    height: '40px',
  };

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
        fontSize={pixify(this.props.fontSize)}
        height={pixify(this.props.height)}
        id='breadcrumbs'
      >
        {
          this.props.breadcrumbs.map((item, index) => {
            return (
              <Breadcrumb
                key={`breadcrumb-${index}`}
              >
                {
                  isPresent(item.routeToName) ?
                    <BreadcrumbLink
                      to={{name: item.routeToName, params: item.routeToParams}}
                    >
                      {item.name}
                    </BreadcrumbLink>
                  :
                    <BreadcrumbText>
                      {item.name}
                    </BreadcrumbText>
                }
                {
                  this.props.breadcrumbs[index + 1] &&
                    <i className='fa fa-angle-double-right' />
                }
              </Breadcrumb>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Breadcrumbs);
